const FiltresMateriaux = ({ annonces, filters, onChange }) => {
  const uniqueTypeMateriel = [
    ...new Set(annonces.map((a) => a.typeMateriel).filter(Boolean)),
  ];
  const uniqueEtat = [...new Set(annonces.map((a) => a.etat).filter(Boolean))];

  return (
    <>
      <div>
        <h3>Type de matériel</h3>
        {uniqueTypeMateriel.map((type) => (
          <label key={type}>
            <input
              type="checkbox"
              name="typeMateriel"
              value={type}
              onChange={onChange}
            />
            {type}
          </label>
        ))}
      </div>

      <div>
        <h3>État</h3>
        {uniqueEtat.map((etat) => (
          <label key={etat}>
            <input
              type="checkbox"
              name="etat"
              value={etat}
              onChange={onChange}
            />
            {etat}
          </label>
        ))}
      </div>

      <div>
        <h3>Prix</h3>
        <label>
          Min:
          <input
            type="number"
            name="prixMin"
            value={filters.prixMin}
            onChange={onChange}
            placeholder="Prix minimum"
          />
        </label>
        <label>
          Max:
          <input
            type="number"
            name="prixMax"
            value={filters.prixMax}
            onChange={onChange}
            placeholder="Prix maximum"
          />
        </label>
      </div>
    </>
  );
};

export default FiltresMateriaux;
